// extracted by mini-css-extract-plugin
export default {"Home":"Home_Home__p53W1","banner":"Home_banner__xhXNS","main":"Home_main__lLIAE","bookList":"Home_bookList__6BxQT"};